import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { downloadCSV } from "@/lib/csv";
import { openAgreementDoc } from "@/lib/agreementDoc";

export default function AdminAgreements() {
  const [data, setData] = useState(null);

  const load = async () => {
    try { setData((await api.get("/admin/agreements")).data); }
    catch { toast.error("Couldn't load agreements"); }
  };
  useEffect(() => { load(); }, []);

  const viewSigned = async (vid) => {
    try {
      const { data } = await api.get(`/admin/agreements/${vid}/signed-pdf`);
      const w = window.open("", "_blank");
      if (w && data.pdf) w.document.write(`<iframe src="${data.pdf}" style="border:0;width:100%;height:100vh"></iframe>`);
    } catch { toast.error("No signed copy on file"); }
  };

  if (!data) return <div className="font-mono text-sm">Loading…</div>;
  const rows = data.rows || [];
  const accepted = rows.filter((r) => r.accepted).length;
  const pending = rows.filter((r) => !r.accepted && r.status === "approved").length;

  const exportCsv = () => downloadCSV("vendor-agreements.csv", rows.map((r) => ({
    vendor: r.store_name, status: r.status,
    agreement: r.accepted ? "Accepted" : "Pending",
    accepted_version: r.accepted_version || "", current_version: r.current_version,
    signer: r.signer_name || "", designation: r.designation || "",
    accepted_at: r.accepted_at || "", method: r.method || "", ip: r.ip || "",
  })));

  return (
    <div>
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Compliance</p>
          <h2 className="font-serif text-4xl tracking-tighter">Vendor Agreements.</h2>
          <p className="mt-2 font-mono text-[11px] text-muted-foreground">
            Current version <b>v{data.version}</b> · effective {data.effective_date} · {accepted} accepted · {pending} pending
          </p>
        </div>
        <button onClick={exportCsv} className="font-mono text-[10px] uppercase tracking-widest border border-foreground px-4 py-2 hover:bg-foreground hover:text-background">Export CSV</button>
      </div>

      <div className="overflow-x-auto border border-foreground">
        <table className="w-full text-sm min-w-[820px]">
          <thead>
            <tr className="border-b border-foreground font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="text-left py-3 px-3">Vendor</th>
              <th className="text-left py-3 px-3">Agreement</th>
              <th className="text-left py-3 px-3">Signed by</th>
              <th className="text-left py-3 px-3">When</th>
              <th className="text-left py-3 px-3">Method · IP</th>
              <th className="text-left py-3 px-3">Agreement doc</th>
              <th className="text-left py-3 px-3">Signed copy</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.vendor_id} className="border-b border-foreground/12">
                <td className="py-3 px-3">
                  <p className="font-serif">{r.store_name}</p>
                  <p className="font-mono text-[10px] text-muted-foreground uppercase">{r.status}</p>
                </td>
                <td className="py-3 px-3">
                  {r.accepted ? (
                    <span className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--accent))]">✓ Accepted v{r.accepted_version}</span>
                  ) : r.accepted_version ? (
                    <span className="font-mono text-[10px] uppercase tracking-widest text-destructive">Re-accept due (has v{r.accepted_version})</span>
                  ) : (
                    <span className="font-mono text-[10px] uppercase tracking-widest text-destructive">Pending</span>
                  )}
                </td>
                <td className="py-3 px-3">{r.signer_name ? <>{r.signer_name}<span className="text-muted-foreground">{r.designation ? `, ${r.designation}` : ""}</span></> : "—"}</td>
                <td className="py-3 px-3 font-mono text-[11px]">{r.accepted_at ? new Date(r.accepted_at).toLocaleString("en-IN") : "—"}</td>
                <td className="py-3 px-3 font-mono text-[10px] text-muted-foreground">{r.method || "—"}{r.ip ? ` · ${r.ip}` : ""}</td>
                <td className="py-3 px-3">
                  <button
                    onClick={() => openAgreementDoc(r.accepted_version ? {
                      store_name: r.store_name, signer_name: r.signer_name, designation: r.designation,
                      accepted_at: r.accepted_at, method: r.method, ip: r.ip, version: r.accepted_version,
                    } : null)}
                    className="font-mono text-[10px] uppercase tracking-widest underline hover:text-[hsl(var(--accent))]">
                    {r.accepted_version ? "View signed" : "View"}
                  </button>
                </td>
                <td className="py-3 px-3">
                  {r.has_signed_pdf
                    ? <button onClick={() => viewSigned(r.vendor_id)} className="font-mono text-[10px] uppercase tracking-widest underline hover:text-[hsl(var(--accent))]">View</button>
                    : <span className="font-mono text-[10px] text-muted-foreground">—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
